/* eslint-disable import/default */

import './include-babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/RootProducts';
const store = configureStore();

const el = document.getElementById('appProducts'),
  catId = el.hasAttribute('data-cat-id') ? parseInt(el.getAttribute('data-cat-id')) : undefined,
  subCatId = el.hasAttribute('data-sub-cat-id') ? parseInt(el.getAttribute('data-sub-cat-id')) : undefined,
  brandId = el.hasAttribute('data-brand-id') ? parseInt(el.getAttribute('data-brand-id')) : undefined,
  titleOverride = el.hasAttribute('data-title-override') ? el.getAttribute('data-title-override') : '',
  filter = el.hasAttribute('data-filter') ? el.getAttribute('data-filter') : '',
  prefer = el.hasAttribute('data-prefer') ? el.getAttribute('data-prefer') : '',
  isNonOemFirst = !el.hasAttribute('data-landing');

render(
  <AppContainer>
    <Root store={store}
          history={history}
          catId={catId}
          subCatId={subCatId}
          brandId={brandId}
          titleOverride={titleOverride}
          filter={filter}
          prefer={prefer}
          isNonOemFirst={isNonOemFirst}
    />
  </AppContainer>,
  document.getElementById('appProducts')
);

if (module.hot) {
  module.hot.accept('./components/RootProducts', () => {
    const NewRoot = require('./components/RootProducts').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('appProducts')
    );
  });
}
